import { IAbUseExperiment } from '../../types/abUseExperiments';

export const abUseExperiments = (state: IAbUseExperiment[] = []) => state;
